import React from 'react';
import { InjectorProps } from '../types';

// Iniettore common rail in sezione stilizzata.
// Altezza totale 224px (14rem): la punta coincide con il bordo superiore della camera.
const Injector: React.FC<InjectorProps> = ({ isInjecting }) => {
  const active = !!isInjecting;
  return (
    // z-index elevato per assicurare che il corpo dell'iniettore sia sempre sopra gli effetti della camera
    <div className="relative flex flex-col items-center z-30">
      <svg
        width="120"
        height="224"
        viewBox="0 0 120 224"
        role="img"
        aria-label={active ? 'Iniettore: ugello aperto' : 'Iniettore: ugello chiuso'}
        style={{ overflow: 'visible' }}
      >
        <defs>
          <linearGradient id="inj-metal" x1="0" x2="1" y1="0" y2="0">
            <stop offset="0" stopColor="#334155" />
            <stop offset="0.28" stopColor="#94a3b8" />
            <stop offset="0.5" stopColor="#e2e8f0" />
            <stop offset="0.72" stopColor="#94a3b8" />
            <stop offset="1" stopColor="#334155" />
          </linearGradient>
          <linearGradient id="inj-metal-dark" x1="0" x2="1" y1="0" y2="0">
            <stop offset="0" stopColor="#1e293b" />
            <stop offset="0.35" stopColor="#64748b" />
            <stop offset="0.55" stopColor="#94a3b8" />
            <stop offset="1" stopColor="#1e293b" />
          </linearGradient>
          <linearGradient id="inj-brass" x1="0" x2="0" y1="0" y2="1">
            <stop offset="0" stopColor="#fcd34d" />
            <stop offset="0.5" stopColor="#d97706" />
            <stop offset="1" stopColor="#92400e" />
          </linearGradient>
          <linearGradient id="inj-needle" x1="0" x2="1" y1="0" y2="0">
            <stop offset="0" stopColor="#94a3b8" />
            <stop offset="0.5" stopColor="#f8fafc" />
            <stop offset="1" stopColor="#94a3b8" />
          </linearGradient>
          <radialGradient id="inj-tip-glow" cx="0.5" cy="0.5" r="0.5">
            <stop offset="0" stopColor="#a5f3fc" stopOpacity="0.95" />
            <stop offset="1" stopColor="#22d3ee" stopOpacity="0" />
          </radialGradient>
        </defs>

        {/* Connettore elettrico */}
        <rect x="40" y="0" width="40" height="22" rx="4" fill="#0f172a" stroke="#475569" strokeWidth="1.5" />
        <rect x="48" y="6" width="5" height="10" rx="1" fill="#facc15" />
        <rect x="67" y="6" width="5" height="10" rx="1" fill="#facc15" />

        {/* Mandata carburante ad alta pressione (laterale) */}
        <rect x="80" y="40" width="20" height="14" fill="url(#inj-brass)" />
        <rect x="98" y="36" width="12" height="22" rx="2" fill="url(#inj-metal-dark)" stroke="#475569" />
        <line x1="104" y1="38" x2="104" y2="56" stroke="#0f172a" strokeOpacity="0.5" />

        {/* Corpo superiore con bobina solenoide */}
        <rect x="34" y="22" width="52" height="72" rx="5" fill="url(#inj-metal)" stroke="#475569" strokeWidth="1.5" />
        {[32, 38, 44, 50, 56, 62, 68, 74, 80, 86].map(y => (
          <line key={y} x1="35" x2="85" y1={y} y2={y} stroke="#0f172a" strokeOpacity="0.22" strokeWidth="1" />
        ))}
        {/* Anello indicatore solenoide */}
        <rect
          x="34" y="26" width="52" height="4" rx="1"
          fill={active ? '#22d3ee' : '#334155'}
          style={{ filter: active ? 'drop-shadow(0 0 5px #22d3ee)' : 'none', transition: 'fill 75ms' }}
        />

        {/* Dado esagonale */}
        <rect x="30" y="94" width="60" height="14" rx="2" fill="url(#inj-metal-dark)" stroke="#475569" strokeWidth="1.5" />
        <line x1="45" x2="45" y1="94" y2="108" stroke="#0f172a" strokeOpacity="0.4" />
        <line x1="75" x2="75" y1="94" y2="108" stroke="#0f172a" strokeOpacity="0.4" />

        {/* Corpo inferiore */}
        <rect x="42" y="108" width="36" height="56" fill="url(#inj-metal)" stroke="#475569" strokeWidth="1.5" />

        {/* Finestra di sezione con lo spillo */}
        <rect x="53" y="114" width="14" height="46" rx="2" fill="#0b1220" stroke="#334155" />
        <g
          style={{
            transform: `translateY(${active ? -10 : 0}px)`,
            transition: 'transform 75ms ease-out',
          }}
        >
          <rect x="57" y="124" width="6" height="46" rx="1.5" fill="url(#inj-needle)" />
        </g>

        {/* Ugello conico */}
        <polygon points="44,164 76,164 67,208 53,208" fill="url(#inj-metal-dark)" stroke="#475569" strokeWidth="1.5" />
        <polygon points="53,208 67,208 62,224 58,224" fill="#64748b" stroke="#475569" strokeWidth="1.5" />

        {/* Bagliore della punta quando inietta */}
        <circle
          className="injector-glow"
          cx="60" cy="222" r="14"
          fill="url(#inj-tip-glow)"
          style={{ opacity: active ? 1 : 0 }}
        />
      </svg>
    </div>
  );
};

export default Injector;
